/* eslint-disable no-useless-catch */
import type { Component } from 'vue';
import { AppletDesignConfig } from '@redviking/argonaut-util/types/mes/applet-designs/applet-design-config.zod';
import {
    type Latest,
} from '@redviking/argonaut-util/types/mes/applet-designs/appletDesign.latest.zod';
import { fromZodError, isZodErrorLike } from 'zod-validation-error';
import { appletDesignSchema } from '@redviking/argonaut-util/types/mes/applet-designs/applet-design-config.zod';
import { CausalError } from '@redviking/causal-error';

/** A migration step that requires user action */
export type MigrationStep = {
    component: Component;
    oldVersionNumber: number;
    newVersionNumber: number;
    oldDesignCfg: AppletDesignConfig;
    invalidProviderIds?: string[];
}

export type MigrationPayload<D extends AppletDesignConfig = AppletDesignConfig> = {
    designConfig: D;
    migrationSteps: MigrationStep[];
}

export type LatestMigrationPayload = {
    newConfig: Latest.AppletDesignVersionConfig;
} | {
    migrationSteps: MigrationStep[];
}

export const updateDesignWithComponents = (incomingCfg: unknown): LatestMigrationPayload => {
    try {
        // there are no migration steps requiring user action (yet)
        return {
            newConfig: appletDesignSchema.parse(incomingCfg),
        };
    } catch (e) {
        if (isZodErrorLike(e)) {
            // if this is a zod error, we can improve formatting
            const zodError = fromZodError(e);
            throw CausalError.from({
                message: 'Encountered an error while attempting to parse the config',
                cause: zodError.message,
                zodError,
            });
        }

        throw e;
    }
};
